import { colors } from "../../Styles";

export function Edit({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M98.77,139.12L233.79,9.96c2.84-2.71,7.04-2.93,9.39-.47l18.49,19.33c2.35,2.45,1.95,6.64-.89,9.36L125.76,167.33l-47.99,18.89,21-47.1Z"/>
      <g>
        <path d="M196.88,273.72H32c-12.31,0-22.33-10.06-22.33-22.43V52.07c0-12.37,10.02-22.43,22.33-22.43h81.64v11H32c-6.25,0-11.33,5.13-11.33,11.43v199.21c0,6.3,5.08,11.43,11.33,11.43h164.87c6.25,0,11.33-5.13,11.33-11.43V106.85h11v144.44c0,12.37-10.02,22.43-22.33,22.43Z"/>
        <rect x="113.65" y="29.65" width="42.61" height="11"/>
      </g>
    </svg>
  );
}
